import React from 'react';
import { Card } from '../../../../../../components/Card/Card';
import { Event } from '../../../../../../model/event';
import classnames from 'classnames';
import { t } from '../../../../../../locales/translate';
import { Stack } from '../../../../../../components/Stack/Stack';
import { Grid } from '../../../../../../components/Grid/Grid';
import { WarningCard } from '../../../../../Products/components/WarningCard';
import { graphql } from '../../../../../../generated';
import { List } from '../../../../../../components/list/list';
import { useSuspenseQuery } from '@apollo/client';
import { withSuspendedCard } from '../../../../../../util/suspense';
import { runTicketCodesExport } from '../../../../../../model/exports';

const EVENT_RESALE_SETTING = graphql(`
  query ResaleSettingForTicketcodes($eventId: ID!) {
    event(id: $eventId) {
      id
      resaleSetting {
        preference
      }
    }
  }
`);

interface Props {
  event: Event;
}

function Ticketcodes$({ event }: Props): JSX.Element {
  const { data } = useSuspenseQuery(EVENT_RESALE_SETTING, { variables: { eventId: event.id } });
  const salesStats = event.salesStats;
  const processingStats = salesStats?.processing;
  const cartStats = salesStats?.cart;
  const reservedStats = salesStats?.reserved;
  const warnings = [
    data?.event.resaleSetting.preference === 'ALLOW' ? t.model.event.changeDueToActiveResale : null,

    processingStats ? t.model.event.changeDueToProcessing(processingStats) : null,

    cartStats ? t.model.event.changeDueToCart(cartStats) : null,

    reservedStats ? t.model.event.changeDueToReserved(reservedStats) : null,
  ].filter(Boolean);

  return (
    <Card title={t.model.event.ticketcodes}>
      <Stack>
        {warnings.length > 0 && (
          <WarningCard>
            <List items={warnings} />
          </WarningCard>
        )}
        {event.status !== 'stopped' && <div>{t.model.event.ticketCodesMsg}</div>}
        <Grid flex gap="default">
          <button
            className={classnames('button button--primary', {
              'button--disabled': event.status !== 'stopped',
            })}
            onClick={() => runTicketCodesExport({ eventId: event.id, full: false })}
          >
            {t.model.event.ticketCodesButton}
          </button>
          <button
            className={classnames('button button--dark', {
              'button--disabled': event.status !== 'stopped',
            })}
            onClick={() => runTicketCodesExport({ eventId: event.id, full: true })}
          >
            {t.model.event.fullTicketCodesButton}
          </button>
        </Grid>
      </Stack>
    </Card>
  );
}

export const Ticketcodes = withSuspendedCard(Ticketcodes$, { loadingTitle: t.model.event.ticketcodes });
